/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_AccessorialsInputs */

const en_loading_accessorials = /** @type {(inputs: Loading_AccessorialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading accessorials...`)
};

const es_loading_accessorials = /** @type {(inputs: Loading_AccessorialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando cargos adicionales...`)
};

/**
* | output |
* | --- |
* | "Loading accessorials..." |
*
* @param {Loading_AccessorialsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const loading_accessorials = /** @type {((inputs?: Loading_AccessorialsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_AccessorialsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_accessorials(inputs)
	return es_loading_accessorials(inputs)
});